module.exports = __webpack_public_path__ + "img/portfolio-07-481x325.3cfdacfb.jpg";